import axios from 'axios';
import apiConfig from '../api.config';

export default function checkinConfigRequest(hotelId) {
  const {
    host,
    URIs: { checkinConfig },
  } = apiConfig;

  const uri = `${host}${checkinConfig.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
